import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { Toaster } from "sonner";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0B1B2B", border: "1px solid rgba(212,178,106,0.3)", color: "#F5EFE6" } }} />
  </React.StrictMode>,
);
